import React from 'react';

import ManageMemberships from 'features/organizations/memberships/manage-list';
import {
  ManageOrganizationWrapper,
  EditOrganizationProviderWrapper
} from 'screens/organizations/context/EditOrganizationProvider';

const OrganizationMembershipsScreen = () => <ManageMemberships />;

export default OrganizationMembershipsScreen;

OrganizationMembershipsScreen.getLayout = (page) => (
  <ManageOrganizationWrapper>
    <EditOrganizationProviderWrapper>{page}</EditOrganizationProviderWrapper>
  </ManageOrganizationWrapper>
);
